import { Table, Tag } from "antd";

import ContextMenu from "@/components/containers/ContextMenu";

import { FIELD_TYPES_OPTIONS, DEFINITIONS } from "@/constants/definitions";

const getDueDateFieldName = (field) => {
  if (field.type !== "table") return "-";

  return ( //ANYA что-то одно, как бэк контракт отдаст
    field.due_date_field?.name ||
    field.due_date_field?.caption ||
    field.due_date_field_name ||
    "-"
  );
};

// Таблица полей объекта
// Тут можно настроить колонки
const DefinitionFieldsTable = ({
  data,
  loading,
  pagination,
  isNSPD,
  onChange,
  onDeleteItem,
  onEditItem,
}) => {
  const columns = [
    {
      title: "Название",
      dataIndex: "name",
      key: "name",
      width: 250,
      defaultSortOrder: "ascend",
      sorter: {
        compare: (a, b) => a.name.localeCompare(b.name),
        multiple: 1,
      },
    },

    {
      title: "Тип",
      dataIndex: "type",
      key: "type",
      width: 150,
      ellipsis: true,
      render: (type, field) => {
        if (DEFINITIONS.includes(type)) {
          return <Tag>{field.object_name}</Tag>;
        } else {
          const t = FIELD_TYPES_OPTIONS.find((item) => item.value === type);
          return t ? <Tag color={t.color}>{t.label}</Tag> : <Tag>{type}</Tag>;
        }
      },
    },
    {
      title: "Описание",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Поле срока исполнения",
      dataIndex: "due_date_field",
      key: "due_date_field",
      width: 200,
      ellipsis: true,
      render: (_, field) => getDueDateFieldName(field),
    },
    ...(isNSPD
      ? [
          {
            title: "Связанный ключ НСПД",
            dataIndex: "nspd_key",
            key: "nspd_key",
            width: 200,
            ellipsis: true,
            render: (_, field) => {
              return field.nspd_key?.name || "";
            },
          },
        ]
      : []),
    // {
    //   title: "Временный",
    //   dataIndex: "temporal",
    //   key: "temporal",
    //   width: 110,
    //   align: "center",
    //   render: (temporal) => (temporal ? <CheckIcon /> : ""),
    // },
    {
      title: "",
      width: 48,
      align: "center",
      fixed: "right",
      key: "actions",
      render: (_, item) => (
        <ContextMenu
          vertical
          onEdit={() => onEditItem(item)}
          onDelete={() => onDeleteItem(item)}
        />
      ),
    },
  ];

  return (
    <Table
      dataSource={data}
      columns={columns}
      rowKey="uuid"
      loading={loading}
      pagination={pagination}
      onChange={onChange}
      showSorterTooltip={{
        target: "sorter-icon",
        title: "Нажмите для сортировки",
      }}
      size="small"
      scroll={{
        x: "100%",
        y: 500,
      }}
      tableLayout="fixed"
      bordered
    />
  );
};

export default DefinitionFieldsTable;
